import React, { Component } from "react"
import Roulette from 'react-roulette-game'
import ReactCardFlip from 'react-card-flip';
import ReactDOM from 'react-dom';
import Modal from 'react-modal';
import Dares from './dares.json';
import Lottie from 'react-lottie';
import { Diggy, DiggyJson } from './diggy';

export class FlipModal extends Component {

    constructor(props) {
        super(props)
        this.state = {
            customStyles:{
                content : {
                  top                   : '50%',
                  left                  : '50%',
                  right                 : 'auto',
                  bottom                : 'auto',
                  marginRight           : '-50%',
                  transform             : 'translate(-50%, -50%)',
                  border                : '0px',
                  borderTop             : 'unset',
                  backgroundColor       : 'rgb(0, 0, 0, 0)'
                }
            },
            modalIsOpen: false,
            isFlipped: false,
            shiitgel_level: '',
            shiitgel_json: {}

        }
        this.closeModal = this.closeModal.bind(this);
        this.openModal = this.openModal.bind(this);
        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.questionRandom = this.questionRandom.bind(this);
        this.questionLevel = this.questionLevel.bind(this);

    }
    closeModal(){
        this.setState({modalIsOpen: false, isFlipped: false})
    }
    openModal() {
        this.setState({modalIsOpen:true});
    }
    afterOpenModal() {
    }
    componentDidUpdate(pP, pS){
        if(pP.isFlipped !== this.props.isFlipped)
        {
            const isFlipped = this.props.isFlipped
            this.setState({modalIsOpen:isFlipped})
        }
        if(pP.final !== this.props.final)
        {
            this.questionLevel(this.props.final, this.props.dare)
        }
    }

    questionLevel(level, dare){
        if(level == 'ulaan')
        {
            this.setState({shiitgel_level: 'ulaan'})
            this.questionRandom(Dares[dare]['hard'])
        }
        if(level == 'tsenher')
        {
            this.setState({shiitgel_level: 'tsenher'})
            this.questionRandom(Dares[dare]['medium'])
        }
        if(level == 'nogoon')
        {
            this.setState({shiitgel_level: 'nogoon'})
            this.questionRandom(Dares[dare]['easy'])
        }
        if(level == 'yndoo')
        {
            this.setState({shiitgel_level: 'yndoo'})
        }
    }
    questionRandom(json){
        const randomIndex = Math.floor(Math.random() * json.length)
        this.setState({shiitgel_json:json[randomIndex]})

    }
    render() {
        const {modalIsOpen, customStyles, } = this.state
        return (
        <div>
            <Modal
                isOpen={modalIsOpen}
                style={customStyles}
                contentLabel="Example Modal"
                >
                <ReactCardFlip isFlipped={this.state.isFlipped} flipDirection="vertical">
                    <div>
                        {this.state.shiitgel_level == 'yndoo' ?
                            <div>
                                <a onClick={this.closeModal}><img className="yndoo-back" src={require(`../../static/img/role/aziinback.jpg`)}></img></a>
                                <a onClick={this.closeModal}><img className="yndoo" src={require(`../../static/img/role/shamrock.png`)}></img></a>
                            </div>
                            :
                            this.state.shiitgel_level == 'ulaan' ?
                            <div className="hard-back" onClick={() => this.setState({isFlipped: true})}>
                                <img className="hard" src={require(`../../static/img/role/skull.png`)}></img>
                                <a className="amarhan-title text-decoration-none my-4">Хэцүү шийтгэл</a><br></br>
                            </div>:
                            this.state.shiitgel_level == 'tsenher' ?
                            <div className="medium-back" onClick={() => this.setState({isFlipped: true})}>
                                <img className="medium" src={require(`../../static/img/role/OK.png`)}></img>
                                <a className="amarhan-title text-decoration-none my-4">Дажгүй шийтгэл</a><br></br>
                            </div>:
                            this.state.shiitgel_level == 'nogoon' ?
                            <div className="easy-back" onClick={() => this.setState({isFlipped: true})}>
                                <img className="easy" src={require(`../../static/img/role/joy.png`)}></img>
                                <a className="amarhan-title text-decoration-none my-4">Амархан шийтгэл</a><br></br>
                            </div> : null
                        }
                    </div>
                    <div className="card">
                        <div className="card-body">
                            <div onClick={this.closeModal}  className="shiitgel">
                                {DiggyJson[1].type()}
                                <a className="shiitgel-text">
                                    {this.state.shiitgel_json['text']}
                                </a>
                            </div>
                        </div>
                    </div>
                </ReactCardFlip>
            </Modal>
        </div>
        )

    }

}
